import { ScheduleTourApi } from 'services/Api/schedule/ScheduleTourApi';
import { IStoreTourListResponse } from '../../_domain/_models/IStoreTourListResponse'
import { CategoryMainServiceToStoreTourListResponseUseCase } from './CategoryServiceToStoreTourListResponseUseCase';

export const GetStoreToursByLocaldUseCase = async (localId: string): Promise<IStoreTourListResponse> => {
    const scheduleTourApi = ScheduleTourApi();
    const response = await scheduleTourApi.getMainServiceCategoryByLocalId(localId);
    return CategoryMainServiceToStoreTourListResponseUseCase(response)
}
